import React from "react";
import { Modal, Box, Typography, Fade} from "@mui/material";
import CustomButton from "../../../shared/CustomButton";
const Modalstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  height: 250,
  bgcolor: "background.paper",
  borderRadius: '6px',
  padding:"24px 24px 0 24px",
  display:"flex",
flexDirection:"column"
};
const AssginCustomers = ({
  open,
  onClose,
  touched,
  action,
  children
}) => {


/* const dispatch = useDispatch()

const saveChanges = (rows) => {

    if(open.Type === "1")
    {
        let data ={
   
            "status":1,
            "subscribersId":rows.map((element) => (element.customerId))
        }
        dispatch(CheckTheStatus(data,success,error)).then(() => {
            dispatch(LoadSubscribers(
                {
                  pageNumber:1,
                pageSize:10
              },error))
          onClose({status:false,Type:""}) 
          handleUnselectAll()
        }) 
        }

    else {
        let data ={
   
            "status":0,
            "subscribersId":rows.map((element) => (element.customerId))
        }
        dispatch(CheckTheStatus(data,success,error)).then(() => {
            dispatch(LoadSubscribers(
                {
                  pageNumber:1,
                pageSize:10
              },error))
          onClose({status:false,Type:""}) 
          handleUnselectAll()
        }) 
    }
    

} */



  return (
    <Modal
      open={open}
      onClose={onClose}
      disableEnforceFocus
      disableAutoFocus
 
    >
          <Fade in>
          <Box sx={Modalstyle}>
        <Box>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 500,
              lineHeight: "24px",
              color:"#050D2E",
              marginBottom:"20px"
            }}
          >
Assign to Group
          </Typography>
        </Box>
          <Typography
            id="modal-un-saved-changes"
            sx={{
              color: "#50566E",
              fontSize: "16px",
              fontWeight:400,
              margin:"10px 0"
            }}
          >
        {children}
          </Typography>
       <Box
     sx={{
      alignSelf:"end",
      flexGrow:0.5,
      alignItems:"end",
      display:"flex"
     }}
       >
       <Box
         sx={{
          display:"flex",
          gap:1
         }}
          
        >
          <CustomButton
            text="Cancel"
            type="secondary"
            processing={false}
            action={onClose}
          
          />
          <CustomButton
            text="Assign To Group"
            type="update"
            action={action}
            disabled={!touched}
          />  
        </Box>
       </Box>
      </Box>
          </Fade>
     
    </Modal>
  );
};

export default AssginCustomers;
